import { MealTime } from "@/clients/models/MealTime";
import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useLifeStyle } from "@/features/lifestyle/hooks/use-lifestyle";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import LifestyleSelectionList from "../../components/lifestyle-selection-list";

export default function OnboardingDinner() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const {
    selectedPreference,
    handlePreferenceSelect,
    handleSubmit,
    isUpdating,
    options,
    isLoading,
  } = useLifeStyle(MealTime.DINNER, () => {
    navigation.push(info?.nextPath ?? "", "none");
  });

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="And evening meals?"
        description="Pick all that apply. We’ll tailor your companion to match your usual evening routine."
        className="mt-2 mb-6 w-full"
      />
      <LifestyleSelectionList
        isLoading={isLoading}
        options={options?.lifestyleOptionsData ?? []}
        selectedPreference={selectedPreference}
        handlePreferenceSelect={handlePreferenceSelect}
      />

      <StepsButtons
        previousPath={info?.previousPath}
        type="button"
        disabled={isUpdating}
        onClick={handleSubmit}
      />
    </ProfilePageContainer>
  );
}
